import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full bg-cream py-20 px-4 md:px-6" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-dark mb-6" data-id="element-139">
            El momento exacto
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="prose prose-lg mx-auto text-warm-gray" data-id="element-140">
          <p className="text-xl mb-8" data-id="element-141">
            Si tienes 35+ y sientes que tu cuerpo cambió de idioma:
          </p>

          <ul className="space-y-4 mb-8 list-none pl-0" data-id="element-142">
            <li className="flex items-start gap-3" data-id="element-143">
              <span className="text-teal text-2xl" data-id="element-144">•</span>
              <span className="text-lg" data-id="element-145">
                Antes bajabas “regresando a lo básico”
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-146">
              <span className="text-teal text-2xl" data-id="element-147">•</span>
              <span className="text-lg font-medium text-warm-dark" data-id="element-148">
                Ahora haces lo mismo… y lo único que baja es tu paciencia
              </span>
            </li>
          </ul>

          <div className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-teal my-8" data-id="element-149">
            <p className="text-lg mb-4" data-id="element-150">No es que no sepas qué hacer.</p>
            <p className="text-lg mb-4" data-id="element-151">
              Es que lo que hacías dependía de una cosa que ya no está
              garantizada:{' '}
              <span className="font-bold text-warm-dark" data-id="element-152">
                un cuerpo con margen.
              </span>
            </p>
            <p className="text-lg" data-id="element-153">
              Ahora tu cuerpo no tiene margen. Tiene estrés, picos, sueño roto,
              inflamación… y un cansancio que se disfraza de “falta de
              disciplina”.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}